import { useEffect, useState } from "react";
import { AttributeFieldProps } from "./RenderAttributeInput";
import { GetBusinessFormList } from "vagaro-website-rendering/src/components/Utilities/BusinessData";
import { getNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { componentAttributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import SelectDropdown from "../SelectDropdown";

export default function FormListField(props:AttributeFieldProps){

    const [data,setData] = useState<any>(null);
    let location = getNodeComponentAttributeValue(props.layoutObject,componentAttributeTypes.multiLocation,props.siteData.userContext.businessId);

    
    let currentVal = getNodeComponentAttributeValue(props.layoutObject,props.definition.attKey,"");


    useEffect(()=>{
        setData("loading");

        GetBusinessFormList(props.siteData.userContext,location,(data:any)=>{
            setData(data);

        },(data:any)=>{
            setData("error");


        });

// eslint-disable-next-line
    },[]);

    const options:{label:string,value:string}[] = [{label:"None",value:""}];

    if(data!=null && data!="loading" && data!="error"){
        let found = false;
        for (let i = 0; i < data.length; i++) {
          if (data[i].formId) {
            options.push({ label: data[i].name, value: data[i].formId });
            if (data[i].formId == currentVal) {
              found = true;
            }
          }
        }
        if(!found && currentVal!=""){ // reset the current value when it doesn't exist in the options
            props.updateFunc(props.definition.attKey,"",props.definition.targetType);
            currentVal = "";
        }

    }



    let status = data=="loading"?"loading...":data=="error"?"Oops, something went wrong":"No Forms Found";

   return (
     <>
       <div className={"wb-input-group single-line "}>
         <label className={currentVal == "" ? "not-updated" : "updated"}>
           Form
         </label>
         {options.length > 1 ? (
           <SelectDropdown
             options={options}
             defaultValue={currentVal}
             allowFilter={true}
             onChange={(val: string) => {
               props.updateFunc(
                 props.definition.attKey,
                 val,
                 props.definition.targetType
               );
               props.saveFunc();
             }}
           />
         ) : (
           <div style={{ color: "#999", fontWeight: "500", fontSize: "14px" }}>
             {status}
           </div>
         )}
       </div>
     </>
   );

}